import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "trash-2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M6.25 12.5H10.4167H43.75",
				stroke: "#E04953",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M39.5846 12.5001V41.6668C39.5846 42.7718 39.1456 43.8316 38.3642 44.613C37.5828 45.3944 36.523 45.8334 35.418 45.8334H14.5846C13.4796 45.8334 12.4198 45.3944 11.6384 44.613C10.857 43.8316 10.418 42.7718 10.418 41.6668V12.5001M16.668 12.5001V8.33342C16.668 7.22835 17.107 6.16854 17.8884 5.38714C18.6698 4.60573 19.7296 4.16675 20.8346 4.16675H29.168C30.273 4.16675 31.3328 4.60573 32.1142 5.38714C32.8956 6.16854 33.3346 7.22835 33.3346 8.33342V12.5001",
				stroke: "#E04953",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M20.832 22.9167V35.4167",
				stroke: "#E04953",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M29.168 22.9167V35.4167",
				stroke: "#E04953",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgTrash);
export default ForwardRef;
